import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/jobform/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/appointment-forms', replace: true });
  },
  component: () => null,
});
